var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.047 0.599609H1.03452C0.485522 0.599609 0.0407715 1.04436 0.0407715 1.59336V17.6066C0.0407715 18.1549 0.485522 18.5996 1.03452 18.5996H9.65577V11.6291H7.30977V8.91261H9.65577V6.90936C9.65577 4.58436 11.0755 3.31836 13.15 3.31836C14.1438 3.31836 14.9973 3.39261 15.2463 3.42561V5.85561L13.8078 5.85636C12.6798 5.85636 12.4615 6.39261 12.4615 7.17861V8.91336H15.1518L14.8015 11.6299H12.4615V18.5996H17.0485C17.596 18.5996 18.0408 18.1549 18.0408 17.6059V1.59336C18.0408 1.04436 17.596 0.599609 17.047 0.599609Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.0407715 0.599609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.6d33ace2120ff52f3ee13ada0a522e31.svg";
export { ForwardRef as ReactComponent };